import { axios } from '@Root/API'

export const trackProcess = payload => {
  return axios.post('status-import', payload)
}
